/** Applies to group parts, test parts, params keys. */
export const validQueryPart = /^[a-zA-Z0-9_]+$/;
